import { ICardElementWithChildren, ITopElement } from "backend/model/model";

export const getDateFromMEAValue = (value: number | string | undefined) => {
  if (!value) return undefined;
  const intValue = typeof value === "number" ? value : Number(value);
  if (isNaN(intValue)) {
    return undefined;
  }
  try {
    return new Date(Math.round((intValue - 25569) * 86400 * 1000));
  } catch (e) {
    return undefined;
  }
};

export const formatDate = (
  date: Date | undefined,
  locale: string = "en-GB",
  hasDay: boolean = true
) => {
  if (!date) return "-";
  try {
    //const convertedLocale = locale.indexOf("ar") === 0 ? "ar-ae" : "en-GB";
    let convertedLocale: string;
    if (locale.startsWith("ar")) {
      convertedLocale = "ar-ae";
    } else if (locale.startsWith("fi")) {
      convertedLocale = "fi-FI";
    } else {
      convertedLocale = "en-GB";
    }
   return new Intl.DateTimeFormat(convertedLocale, {
      month: "short",
      year: "numeric",
      day: hasDay ? "2-digit" : undefined,
    }).format(date);
  } catch (e) {
    return "-";
  }
};

export const formatPerformanceValue = (value: unknown) => {
  if (typeof value === "object") return "-";
  if (typeof value === "undefined") return "-";
  if (value === null) return "-";
  if (typeof value !== "string") return "-";
  const n = Number.parseFloat(value);
  if (isNaN(n)) return "-";
  return `${Math.round(n)}`;
};

export const buildTree=(data: ITopElement[] | undefined): ICardElementWithChildren[] =>{
    const scMap: Map<string, ICardElementWithChildren> = new Map();
    const rootSCs: ICardElementWithChildren[] = [];    
    data?.forEach(item => {
      scMap.set(item.scorecardid || "", {...item as ICardElementWithChildren, children:[]});
    });    
    data?.forEach(item => {
      const parent = scMap.get(item.scorecardparentscorecardid || "");
      if (parent ) {
        parent.children.push(scMap.get(item.scorecardid || "")!);
      } else {        
        rootSCs.push(scMap.get(item.scorecardid || "")!);
      }
    });  
    return rootSCs.filter(item=> item.name !== "_configurations");
  }